import { render } from "./TablaRetorno.vue?vue&type=template&id=5c05667d&scoped=true"
import script from "./TablaRetorno.vue?vue&type=script&lang=js"
export * from "./TablaRetorno.vue?vue&type=script&lang=js"

import "./TablaRetorno.vue?vue&type=style&index=0&id=5c05667d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c05667d"]])

export default __exports__